(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["binder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('mc-binder-waitlist')) return;

    const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

    class McBinderWaitlist extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;

        this.dialog = this.querySelector('[data-bw-dialog]');
        this.form = this.querySelector('.mc-bw__form');
        this.email = this.querySelector('[data-bw-email]');
        this.errorEl = this.querySelector('[data-bw-error]');
        this.submitBtn = this.querySelector('[data-bw-submit]');
        this.formState = this.querySelector('[data-bw-state="form"]');
        this.successState = this.querySelector('[data-bw-state="success"]');
        this.provider = this.dataset.provider || 'shopify';

        if (this.form) this.form.noValidate = true;

        this.querySelectorAll('[data-bw-open]').forEach((btn) =>
          btn.addEventListener('click', () => this.open())
        );
        this.querySelector('[data-bw-close]')?.addEventListener('click', () => this.close());
        this.dialog?.addEventListener('click', (e) => {
          if (e.target === this.dialog) this.close();
        });
        this.dialog?.addEventListener('close', () => this.unlockScroll());
        this.form?.addEventListener('submit', (e) => this.onSubmit(e));
        this.email?.addEventListener('input', () => this.setError(''));

        this.setupReveal();
        this.checkServerResult();
      }

      disconnectedCallback() {
        this._observer?.disconnect();
        this.unlockScroll();
      }

      /* --- Animacion de entrada ---------------------------------------- */
      setupReveal() {
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (this.dataset.animate !== 'true' || reduce || !('IntersectionObserver' in window)) return;

        this.classList.add('is-animated');
        this._observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              this.classList.add('is-in');
              this._observer.disconnect();
            });
          },
          { threshold: 0.15, rootMargin: '0px 0px -6% 0px' }
        );
        this._observer.observe(this);
      }

      /* --- Modal -------------------------------------------------------- */
      open() {
        if (!this.dialog) return;
        if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
        else this.dialog.setAttribute('open', '');
        this.lockScroll();

        if (window.matchMedia('(pointer: fine)').matches && !this.formState.hidden) {
          requestAnimationFrame(() => this.email?.focus({ preventScroll: true }));
        }
      }

      close() {
        if (!this.dialog) return;
        if (typeof this.dialog.close === 'function') this.dialog.close();
        else this.dialog.removeAttribute('open');
        this.unlockScroll();
      }

      lockScroll() {
        const html = document.documentElement;
        if (html.dataset.mcBwLock) return;
        html.dataset.mcBwLock = html.style.overflow || 'none';
        html.style.overflow = 'hidden';
      }

      unlockScroll() {
        const html = document.documentElement;
        if (!html.dataset.mcBwLock) return;
        const prev = html.dataset.mcBwLock;
        html.style.overflow = prev === 'none' ? '' : prev;
        delete html.dataset.mcBwLock;
      }

      /* --- Envio -------------------------------------------------------- */
      setError(msg) {
        if (!this.errorEl) return;
        this.errorEl.textContent = msg || '';
        if (msg) this.email?.setAttribute('aria-invalid', 'true');
        else this.email?.removeAttribute('aria-invalid');
      }

      setLoading(on) {
        if (!this.submitBtn) return;
        this.submitBtn.disabled = on;
        this.submitBtn.classList.toggle('is-loading', on);
        this.submitBtn.setAttribute('aria-busy', on ? 'true' : 'false');
      }

      showSuccess() {
        this.formState.hidden = true;
        this.successState.hidden = false;
        this.successState.querySelector('[data-bw-success-title]')?.focus({ preventScroll: true });

        try {
          window.Shopify?.analytics?.publish?.('mintcased_binder_waitlist_join', { provider: this.provider });
        } catch (e) {}
        try {
          if (typeof window.gtag === 'function') {
            window.gtag('event', 'generate_lead', { event_category: 'binder_waitlist', event_label: 'first_drop' });
          }
        } catch (e) {}
      }

      async onSubmit(e) {
        e.preventDefault();
        if (this._busy) return;

        const value = (this.email?.value || '').trim();
        if (!EMAIL_RE.test(value)) {
          this.setError(this.dataset.msgEmail);
          this.email?.focus();
          return;
        }

        this._busy = true;
        this.setLoading(true);
        this.setError('');

        // Si la pagina empieza a navegar durante el envio (p. ej. la proteccion
        // anti-spam de Shopify reenvia el formulario de forma nativa), el fetch
        // se aborta: eso NO es un error real, asi que no lo mostramos.
        let leaving = false;
        let keepLoading = false;
        const onLeave = () => { leaving = true; };
        window.addEventListener('beforeunload', onLeave);

        try {
          let result;
          if (this.provider === 'klaviyo') result = await this.sendKlaviyo(value);
          else if (this.provider === 'custom') result = await this.sendCustom(value);
          else result = await this.sendShopify();

          if (result === 'native') {
            // Shopify pide captcha: envio clasico del formulario (recarga la pagina
            // y el modal se reabre en estado de exito al volver).
            try { sessionStorage.setItem('mcBwPending', this.dataset.formId); } catch (e) {}
            keepLoading = true;
            HTMLFormElement.prototype.submit.call(this.form);
            return;
          }
          if (!leaving) this.showSuccess();
        } catch (err) {
          // Espera breve: si la pagina esta navegando (envio nativo en curso),
          // el navegador la descarga antes de que salte el temporizador y no
          // se llega a mostrar ningun error.
          await new Promise((r) => setTimeout(r, 1200));
          if (leaving) {
            keepLoading = true;
            return;
          }
          const isNetwork = err && (err.name === 'AbortError' || err instanceof TypeError);
          if (isNetwork && this.provider === 'shopify') {
            // Fallo de red/fetch: en vez de mostrar error, envio nativo.
            try { sessionStorage.setItem('mcBwPending', this.dataset.formId); } catch (e) {}
            keepLoading = true;
            HTMLFormElement.prototype.submit.call(this.form);
            return;
          }
          this.setError((err && err.userMessage) || this.dataset.msgGeneric);
        } finally {
          window.removeEventListener('beforeunload', onLeave);
          if (!keepLoading) {
            this._busy = false;
            this.setLoading(false);
          }
        }
      }

      /* Shopify: crea/actualiza el cliente con aceptacion de email marketing
         y las etiquetas de la waitlist. */
      async sendShopify() {
        const res = await fetch(this.form.action, {
          method: 'POST',
          body: new FormData(this.form),
          credentials: 'same-origin',
          headers: { Accept: 'text/html' },
        });

        if (/\/challenge/.test(res.url)) return 'native';
        if (!res.ok) throw new Error('shopify ' + res.status);
        if (/customer_posted=true/.test(res.url)) return 'ok';

        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const scoped = doc.getElementById(this.dataset.formId);
        if (scoped?.querySelector('[data-bw-posted]')) return 'ok';
        const serverError = scoped?.querySelector('[data-bw-server-error]')?.textContent.trim();
        if (serverError) {
          const err = new Error('shopify form error');
          err.userMessage = serverError;
          throw err;
        }
        // Respuesta inesperada: deja que Shopify lo gestione de forma nativa.
        return 'native';
      }

      /* Klaviyo Client API: solo usa la clave PUBLICA (Site ID), segura en frontend. */
      async sendKlaviyo(email) {
        const key = this.dataset.klaviyoKey;
        const list = this.dataset.klaviyoList;
        if (!key || !list) throw new Error('Klaviyo: falta Public API Key o List ID');

        const res = await fetch(
          'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(key),
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' },
            body: JSON.stringify({
              data: {
                type: 'subscription',
                attributes: {
                  custom_source: this.dataset.klaviyoSource,
                  profile: {
                    data: {
                      type: 'profile',
                      attributes: {
                        email,
                        properties: {
                          mintcased_waitlist: 'binder-first-drop',
                          waitlist_locale: this.dataset.locale,
                        },
                      },
                    },
                  },
                },
                relationships: { list: { data: { type: 'list', id: list } } },
              },
            }),
          }
        );
        if (!res.ok) throw new Error('klaviyo ' + res.status);
        return 'ok';
      }

      /* Endpoint propio (Zapier, Make, n8n, Shopify Flow via webhook...). */
      async sendCustom(email) {
        const endpoint = this.dataset.endpoint;
        if (!endpoint) throw new Error('Falta el endpoint');
        const res = await fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            email,
            source: 'mintcased-binder-waitlist',
            tags: this.dataset.tags,
            locale: this.dataset.locale,
            page: window.location.href,
          }),
        });
        if (!res.ok) throw new Error('endpoint ' + res.status);
        return 'ok';
      }

      /* Vuelta de un envio nativo (sin JS o tras captcha). */
      checkServerResult() {
        if (this.provider !== 'shopify' || !this.form) return;
        const posted = this.form.querySelector('[data-bw-posted]');
        const serverError = this.form.querySelector('[data-bw-server-error]');
        let pending = null;
        try {
          pending = sessionStorage.getItem('mcBwPending');
          sessionStorage.removeItem('mcBwPending');
        } catch (e) {}
        const isOurs = pending === this.dataset.formId || window.location.hash === '#' + this.dataset.formId;
        if (!isOurs || (!posted && !serverError)) return;

        this.open();
        if (posted) this.showSuccess();
        else this.setError(serverError.textContent.trim() || this.dataset.msgGeneric);
      }
    }

    customElements.define('mc-binder-waitlist', McBinderWaitlist);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mintcased-binder-bar"] && !Shopify.designMode) return;
  try {
    
  /* Animacion de scroll unica para todas las secciones (ver mintcased-tweaks.css). */
  (() => {
    if (window.Shopify && window.Shopify.designMode) return;
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const root = document.documentElement;
    if (root.classList.contains('mc-sr')) return;

    const init = () => {
      const sections = document.querySelectorAll(
        '#MainContent > .shopify-section, main > .shopify-section, .shopify-section-group-footer-group'
      );
      if (!sections.length) return;
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('mc-sr-in');
            io.unobserve(entry.target);
          });
        },
        { threshold: 0, rootMargin: '0px 0px -8% 0px' }
      );
      const limit = window.innerHeight * 0.92;
      sections.forEach((section) => {
        if (section.classList.contains('mc-sr-item')) return;
        section.classList.add('mc-sr-item');
        if (section.getBoundingClientRect().top < limit) {
          section.classList.add('mc-sr-in');
        } else {
          io.observe(section);
        }
      });
      root.classList.add('mc-sr');
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
